module.exports = __webpack_public_path__ + "static/media/meetings.9907481e.svg";